import { jsx as _jsx } from "react/jsx-runtime";
import { get } from 'lodash';
import { styled } from 'styled-components';
import { Button } from '@design-system/button';
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { s__ } from '@design-system/i18n';
import { primaryShadow } from '@design-system/theme';
export const Control = ({ breakpoint, currentSlide, infinite, isPrev, itemsCount, loading, navTopPosition, nextSlide, perPage, previousSlide, total, }) => {
    const totalItems = total !== null && total !== void 0 ? total : itemsCount;
    const pickDir = (forPrev, forNext) => isPrev ? forPrev : forNext;
    const ariaLabelPrevPage = s__('Accessibility|Display previous results');
    const ariaLabelNextPage = s__('Accessibility|Display next results');
    const ariaLabel = pickDir(ariaLabelPrevPage, ariaLabelNextPage);
    const dataTestId = pickDir('slider-arrow-previous', 'slider-arrow-next');
    const isEdge = pickDir(currentSlide === 0 && !infinite, currentSlide + perPage >= itemsCount + Number(loading) && !infinite);
    const isDisabled = pickDir(false, isEdge);
    const isHidden = pickDir(isEdge, totalItems % perPage > 0 &&
        currentSlide >= totalItems - perPage + 1 &&
        !infinite);
    const onClick = pickDir(previousSlide, nextSlide);
    return isHidden ? null : (_jsx(StyledButton, { "$breakpoint": breakpoint, "$isPrev": isPrev, "$navTopPosition": navTopPosition, "aria-label": ariaLabel, dataTestId: dataTestId, icon: () => (_jsx(FontAwesomeIcon, { height: "20px", iconName: isPrev ? 'angle-left' : 'angle-right', iconType: CATEGORIES.REGULAR })), isDisabled: isDisabled, onClick: onClick, size: "small", variant: "inversed" }));
};
const StyledButton = styled(Button).attrs(({ $isPrev }) => ({
    ml: $isPrev ? -4 : undefined,
    mr: $isPrev ? undefined : -4,
})) `
  ${primaryShadow}
  pointer-events: auto;
  top: ${({ $breakpoint, $navTopPosition }) => get($navTopPosition, $breakpoint, $navTopPosition)};
  ${({ $isPrev }) => ($isPrev ? 'left: 0;' : 'right: 0;')}
  ${({ $navTopPosition }) => $navTopPosition ? 'position: absolute;' : undefined}
`;
//# sourceMappingURL=Control.js.map